import { useExternalHref } from 'src/hooks/useExternalHref';
import { useLanguagesLinks } from '../useLanguagesLinks';
import { useCoursesLinks } from '../useCoursesLinks';
import { usePhrasebooksLinks } from '../usePhrasebooksLinks';
import { useTermsLinks } from '../useTermsLinks';
import { useGeneralLinks } from '../useGeneralLinks';

export const useLanguagePairLinks = () => {
  const signInHref = useExternalHref({
    linkType: 'memrise-localized-signin',
  });
  const signUpHref = useExternalHref({ linkType: 'memrise-signup' });
  const blogHref = useExternalHref({ linkType: 'memrise-blog' });
  const languagesLinks = useLanguagesLinks();
  const coursesLinks = useCoursesLinks();
  const phrasebookLinks = usePhrasebooksLinks();
  const generalLinks = useGeneralLinks();
  const termsLinks = useTermsLinks();

  return {
    signInHref,
    signUpHref,
    blogHref,
    languagesLinks,
    coursesLinks,
    phrasebookLinks,
    generalLinks,
    termsLinks,
  };
};
